import React from "react";
import BranchLink from "web/react/components/branch-link/branch-link";
import styles from "./promo-banner.css";

function PromoPicture(_ref) {
  var mobile = _ref.mobile,
      tablet = _ref.tablet,
      desktop = _ref.desktop,
      desktopXl = _ref.desktopXl,
      altText = _ref.altText;
  return React.createElement("picture", {
    className: styles.picture
  }, desktopXl && React.createElement("source", {
    srcSet: desktopXl,
    media: "(min-width: 1200px)"
  }), desktop && React.createElement("source", {
    srcSet: desktop,
    media: "(min-width: 768px)"
  }), tablet && React.createElement("source", {
    srcSet: tablet,
    media: "(min-width: 576px)"
  }), mobile && React.createElement("source", {
    srcSet: mobile,
    media: "(max-width: 575px)"
  }), React.createElement("img", {
    className: styles.image,
    src: desktop || "",
    alt: altText
  }));
}

export function PromoBanner(_ref2) {
  var url = _ref2.url,
      mobile = _ref2.mobile,
      tablet = _ref2.tablet,
      desktop = _ref2.desktop,
      desktopXl = _ref2.desktop_xl,
      altText = _ref2.alt_text,
      isBranchLink = _ref2.is_branch_link;

  if (mobile == null && tablet == null && desktop == null && desktopXl == null) {
    return null;
  }

  var promoPicture = React.createElement(PromoPicture, {
    mobile: mobile,
    tablet: tablet,
    desktop: desktop,
    desktopXl: desktopXl,
    altText: altText
  });
  return React.createElement("div", {
    className: styles.container
  }, isBranchLink ? React.createElement(BranchLink, {
    title: "",
    branchLink: url,
    eventLabel: "homepage_promo"
  }, promoPicture) : React.createElement("a", {
    href: url
  }, promoPicture));
}
export default PromoBanner;